/**
 * Shared date formatting — one vocabulary for every surface (en-IN).
 * Do not hand-roll `toLocaleDateString` in routes/components; add a helper here.
 */

/** Short calendar date — "16 Aug", or "16 Aug 2026" with `withYear`. */
export function formatShortDate(ms: number, withYear = false): string {
  return new Date(ms).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    ...(withYear ? { year: "numeric" } : {}),
  })
}

function dayAndTime(ms: number, withYear: boolean): string {
  const d = new Date(ms)
  const day = d.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(withYear ? { year: "numeric" } : {}),
  })
  const time = d.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
  })
  return `${day} · ${time}`
}

/** Full event date + time — e.g. "Sat 21 Sept 2026 · 10:00 am". */
export function formatEventDateTime(ms: number): string {
  return dayAndTime(ms, true)
}

/** Compact card date + time, no year — e.g. "Sat 21 Sept · 10:00 am". */
export function formatCardDateTime(ms: number): string {
  return dayAndTime(ms, false)
}

/** Relative time — "Just now", "3m ago", "5h ago", "3d ago", then a short date. */
export function formatRelativeTime(ms: number): string {
  const mins = Math.round((Date.now() - ms) / 60000)
  if (mins < 1) return "Just now"
  if (mins < 60) return `${mins}m ago`
  const hours = Math.round(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  if (days < 7) return `${days}d ago`
  return formatShortDate(ms)
}
